<template>
<div class="sections-container">
  <div class="header-sections">
    <span class="title-section">Catálogo de Productos</span>

    <div class="filter-colum-sections">
      <v-text-field
          style="width: 320px;"
          type="text"
          placeholder="Buscar"
          v-model="currentSearch"
          color="#222222"
          clearable
          @click:clear="clearSearch"
          variant="underlined">
          <template v-slot:append-inner>
            <v-icon color="#222222" icon="mdi-magnify" size="small"/>
          </template>
        </v-text-field>
    </div>
  </div>
  <div class="select-filter-container">
    <div></div>
    <div class="select-filter-container-right">
      <v-btn
          append-icon="mdi-download"
          variant="text"
          style=" margin-right: 20px;"
          color="#FF5700"
          @click="exportExcel">
            Descargar Registros
      </v-btn>
      <div class="autocomplete-container">
        <span class="title-filter">POS:</span>
        <v-select
          v-model="filterSelected"
          :items="filterData"
          item-title="label"
          item-value="value"
          density="compact"
          hide-details="auto"
          variant="solo"
          class="no-bg"/>
      </div>
    </div>
  </div>

  <catalog-table :Products="dataResponse" @refreshList="getList"/>

  <div v-if="totalPages > page"
    class="container-btn-more">
    <button class="btn-text" @click="moreData">
      + Mostrar más
    </button>
  </div>

  <div class="fab-button" @click="addModal">
    <v-icon icon="mdi-plus"></v-icon>
  </div>

  <add-edit-products ref="addEditModal" @refreshList="getList"/>
</div>
</template>
<script>

import CatalogTable from '../tables/CatalogTable.vue'
import terminalsApi from '@/api/terminalsApi'
import AddEditProducts from '../forms/AddEditProducts.vue'
import catalogApi from '@/api/catalogApi'
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  name: 'CommerciaVueCatalog',
  components: {
    CatalogTable,
    AddEditProducts
  },
  data () {
    return {
      business: this.$store.getters.business,
      currentSearch: '',
      filterSelected: 'Todos',
      filterData: [{ value: 'Todos', label: 'Todos' }],
      dataResponse: [],
      page: 1,
      totalPages: 0
    }
  },
  computed: {
    busines () {
      return this.$store.getters.business
    },
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    if (this.user?.role === 'finance') {
      this.$router.push({ name: 'dashboard' })
    }
    this.getPos()
    this.getList()
  },
  watch: {
    currentSearch (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    filterSelected (newVal, oldVal) {
      this.page = 1
      this.getList()
    }
  },
  methods: {
    moreData () {
      this.page += 1
      this.getList()
    },
    clearSearch () {
      this.page = 1
      this.currentSearch = ''
      this.getList()
    },
    addModal () {
      this.$refs.addEditModal.add()
    },
    async getPos () {
      const listPos = await terminalsApi.list(this.business._id, '')
      for (const item of listPos) {
        this.filterData.push({ value: item._id, label: item.name })
      }
    },
    async getList () {
      if (this.filterSelected === 'Todos') {
        const dataRes = await catalogApi.listByBussines(
          this.business._id,
          this.currentSearch,
          this.page, 20)

        this.dataResponse = this.page === 1
          ? (dataRes.products || [])
          : [...this.dataResponse, ...(dataRes.products || [])]
        this.totalPages = dataRes.totalPages || 0

        // this.dataResponse = await catalogApi.listByBussines(this.business._id, this.currentSearch, this.page, 20)
      } else {
        const dataRes = await catalogApi.listByPos(
          this.filterSelected,
          this.currentSearch,
          this.page, 20)

        this.dataResponse = this.page === 1
          ? (dataRes.products || [])
          : [...this.dataResponse, ...(dataRes.products || [])]
        this.totalPages = dataRes.totalPages || 0

        // this.dataResponse = await catalogApi.listByPos(this.filterSelected, this.currentSearch, this.page, 20)
      }
    },
    async exportExcel () {
      let dataRes = null
      if (this.filterSelected === 'Todos') {
        dataRes = await catalogApi.listByBussines(this.business._id, this.currentSearch, this.page, 10000)
      } else {
        dataRes = await catalogApi.listByPos(this.filterSelected, this.currentSearch, this.page, 10000)
      }

      const dataProductsExcel = []
      dataProductsExcel.push(['CODIGO', 'NOMBRE', 'CATEGORIA', 'PRECIO', 'PRECIO ESP.',
        'EXISTENCIAS', 'IMPORTE', 'TERMINAL'])

      for (const item of dataRes.products) {
        dataProductsExcel.push(
          [
            item.sku,
            item.name,
            item.category.name,
            item.price,
            item.promo_price,
            item.stock,
            item.stock * item.price,
            item.terminal.name
          ]
        )
      }

      const workbook = XLSX.utils.book_new()

      const data = XLSX.utils.aoa_to_sheet(dataProductsExcel)
      const boock = 'Productos'
      XLSX.utils.book_append_sheet(workbook, data, boock)

      XLSX.writeFile(workbook, 'Productos.xlsx')
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/sections.css';
  @import '@/assets/styles/inputs.css';
</style>
